export default __webpack_public_path__ + "static/media/Accounting.4f720cab.png";